import { computed } from 'vue';
import { getRecommend } from 'src/api/common';
import { useRequest } from 'src/utils/hooks/use-requset';
import { useRoute } from 'src/utils/v2_helper/router';

const RECOMMEND_TYPE = {
  'products-list': 'LIST_PAGE',
  'order-again': 'LIST_PAGE',
  'product-detail': 'DETAIL_PAGE',
  checkout: 'CHECKOUT_PAGE',
  CartConfirm: 'CHECKOUT_PAGE',
};

export function useRecommendData() {
  const route = useRoute();
  const routeScope = computed(() => RECOMMEND_TYPE[route.name]);

  const { data, error, loading, run } = useRequest(getRecommend, {
    params: { scope: routeScope.value },
    immde: true,
  });

  const listData = computed(() => {
    const _data = data.value?.data || [];
    if (route.name === 'product-detail') {
      return _data.filter((it) => it.id !== route.params.id);
    }
    return _data;
  });

  return { listData, RECOMMEND_TYPE, routeScope, run }
}
